import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, Text, View } from 'react-native';
import { LOCATIONS_WITH_COUNT, HIDE_LOCATION } from './queries';
import { useMutation } from '@apollo/client';
import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { abbreviations as states} from 'app/src/elements/states';
import Modal from '../../elements/Modal';
import EditLocation from './edit';

import {
  LocationsContainer
} from './elements';
import { MainContainer, ContentContainer } from '../../elements';

const inputStyle = {
  marginBottom: '10px'
}

const Locations = () => {
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedLocation, setClickedLocation] = useState();
  const [showEditLocationModal, setShowEditLocationModal] = useState(false);
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const [hideLocation] = useMutation(
    HIDE_LOCATION, { onCompleted: refetch }
  )

  const onHide = (locationId) => {
    hideLocation({ variables: { id: locationId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'stateId',
      label: 'State ID',
      sort: 'asc',
    },
    {
      key: 'name',
      label: 'Name',
    },
    {
      key: 'street',
      label: 'Address',
    },
    {
      key: 'city',
      label: 'City',
    },
    {
      key: 'state',
      label: 'State',
    },
    {
      key: 'postalCode',
      label: 'Zip',
      content: (entry) => {
        return entry.entry.postalCode?.formatted
      }
    },
    {
      key: 'phoneNumber',
      label: 'Phone',
      minViewportWidth: 1000,
      headerStyle: { minWidth: 120 },
      value: (entry) => entry.entry.phoneNumber?.formatted,
      content: (entry) => entry.entry.phoneNumber?.formatted
    },
    {
      key: 'equiplincContact',
      label: 'ELAG POC',
      value: ({ value }) => (
        value ? `${value?.firstName} ${value?.lastName}` : null
      ),
      content: ({ entry, value }) => (
        <>
          <Text>{value}</Text>
          {value && !entry.equiplincContact?.phoneNumber?.formatted && (
            <Text style={{color: 'red', marginLeft: 4}}>NO PHONE #</Text>
          )}
        </>
      )
    },
    {
      key: 'storageFee',
      headerStyle: { maxWidth: 90 },
      label: 'Storage Fee Notes:',
    },
    {
      key: 'release',
      label: 'Release Customizations',
      headerStyle: { maxWidth: 130 },
      sort: 'prevent',
      content: ({ entry }) => (
        <>
          {entry.storageFeeText && (
            <View>
              <Text>Storage Fee</Text>
            </View>
          )}
        </>
      )
    },
    {
      key: 'releaseYardContact',
      label: 'Yard POC'
    },
    {
      key: 'releaseYardEmail',
      label: 'Yard Email'
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => {
        return (
          <div style={{display: 'inline-flex'}}>
            <Pressable
              onPress={() => {
                setClickedLocation(entry);
                setShowEditLocationModal(true);
              }}
            >
              <Text>Edit</Text>
            </Pressable>
            <Text>{' | '}</Text>
            <Pressable
              onPress={() => window.confirm('Hide Location?', onHide(entry.id))}
            >
              <Text>Hide</Text>
            </Pressable>
          </div>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Street:</Text>
          <input
            type={'text'}
            name="Street"
            onChange={e => setFilter('street', e.target.value)}
            value={filters.street || ''}
            style={inputStyle}
          />
          <Text>City:</Text>
          <input
            type={'text'}
            name="City"
            onChange={e => setFilter('city', e.target.value)}
            value={filters.city || ''}
            style={inputStyle}
          />
          <Text>State:</Text>
          <select
            type={'select'}
            name="state"
            onChange={e => setFilter('state', e.target.value)}
            value={filters.state || ''}
          >
            <option key={`state-all`}>
              {'All'}
            </option>
            {states.map(state =>
              <option key={`state-${state}`}>
                {state}
              </option>
            )}
          </select>
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav refetch={refetch} />
      <ContentContainer>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={LOCATIONS_WITH_COUNT}
          queryName='locationsWithCount'
          columns={columns}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.locationsWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
        {showEditLocationModal &&
        <Modal
          refetch={refetch}
          showModal={showEditLocationModal}
          setShowModal={setShowEditLocationModal}
          modalType={'Edit Location'}
          objectName={clickedLocation.name}
        >
          <EditLocation
            setShowModal={setShowEditLocationModal}
            refetch={refetch}
            location={clickedLocation}
          />
        </Modal>
      }
      </ContentContainer>
    </MainContainer>
  )
}

export default Locations;
